import React, { useEffect , useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import Dropzone from "react-dropzone"
// action
import { registerUser, apiError } from "../../slices/thunk";
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange
} from "../../slices/auth/register/reducer";
// ./reducer
//redux
import { useSelector, useDispatch } from "react-redux";

import { Link ,useNavigate } from "react-router-dom";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logoImg from "../../assets/images/darklogo.png";
import { createSelector } from 'reselect';


// Countries and States lists
const COUNTRIES = [
  'United States', 'Canada', 'United Kingdom', 'Australia', 'Germany', 'France',
  'India', 'China', 'Japan', 'Mexico', 'Brazil', 'Other'
];

const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
  'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
  'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
  'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
  'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
  'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

const CANADIAN_PROVINCES = [
  'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador',
  'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island',
  'Quebec', 'Saskatchewan', 'Yukon'
];

const getStatesForCountry = (country: string): string[] => {
  if (country === 'United States') return US_STATES;
  if (country === 'Canada') return CANADIAN_PROVINCES;
  return [];
};

const formatPhoneForDisplay = (value: string): string => {
  if (!value) return '';
  const numbers = value.replace(/\D/g, '');
  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 6) return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
  return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
};

const Register = props => {
  const navigate  = useNavigate()
  const [selectedFiles, setselectedFiles] = useState<any>([])
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [noCompany, setNoCompany] = useState(false);
  function handleAcceptedFiles(files:any) {
    console.log('files',files)
    const updatedFiles = files.map((file: any) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
  
    setselectedFiles(updatedFiles); // for preview
    validation.setFieldValue("filedata", updatedFiles); // 👈 inform Formik
  }
  function formatBytes(bytes:any, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  //meta title
  document.title = "Register | BizServe";

  const dispatch = useDispatch<any>();

    const validateEmail = (email: string) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    
    const validatePhone = (phone: string) => {
      const phoneRegex = /^\+?[0-9]{1,3}?[0-9]{9}$/; // Allows country code + 10 digits
      return phoneRegex.test(phone);
    };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      filedata: null,
      // Company fields
      company_name: '',
      address_line1: '',
      address_line2: '',
      city: '',
      state: '',
      zipcode: '',
      country: 'United States',
      company_phone: '',
      company_email: '',
      website: '',
      entity_type: '',
      year_of_formation: '',
      // Personal address fields (when no company)
      personal_address_line1: '',
      personal_address_line2: '',
      personal_city: '',
      personal_state: '',
      personal_zipcode: '',
      personal_country: 'United States',
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required("Please Enter Your Email").test("is-valid-email", "Invalid email format", (value) => validateEmail(value || "")),
      firstname:  Yup.string().required("Please Enter Your Firstname"),
      lastname:   Yup.string().required("Please Enter Your Lastname"),
      phone: Yup.string().required("Please Enter Your phone").test("is-valid-phone", "Invalid phone number", (value) => validatePhone(value || "")),
      // Conditional company fields - only required if noCompany is false
      company_name: Yup.string().when([], {
        is: () => !noCompany,
        then: (schema) => schema.required("Company name is required"),
        otherwise: (schema) => schema.nullable()
      }),
      address_line1: Yup.string().when([], {
        is: () => !noCompany,
        then: (schema) => schema.required("Address is required"),
        otherwise: (schema) => schema.nullable()
      }),
      city: Yup.string().when([], {
        is: () => !noCompany,
        then: (schema) => schema.required("City is required"),
        otherwise: (schema) => schema.nullable()
      }),
      state: Yup.string().when([], {
        is: () => !noCompany,
        then: (schema) => schema.required("State is required"),
        otherwise: (schema) => schema.nullable()
      }),
      zipcode: Yup.string().when([], {
        is: () => !noCompany,
        then: (schema) => schema.required("Zipcode is required").min(3, 'Zipcode must be at least 3 characters').max(10, 'Zipcode must be at most 10 characters'),
        otherwise: (schema) => schema.nullable()
      }),
      country: Yup.string().when([], {
        is: () => !noCompany,
        then: (schema) => schema.required("Country is required"),
        otherwise: (schema) => schema.nullable()
      }),
      company_phone: Yup.string().when([], {
        is: () => !noCompany,
        then: (schema) => schema.required("Company phone is required").test('phone-length', 'Phone must be 10 digits', (value) => {
          if (!value) return false;
          const digits = value.replace(/\D/g, '');
          return digits.length === 10;
        }),
        otherwise: (schema) => schema.nullable()
      }),
      company_email: Yup.string().when([], {
        is: () => !noCompany,
        then: (schema) => schema.email("Invalid email").required("Company email is required"),
        otherwise: (schema) => schema.nullable()
      }),
      year_of_formation: Yup.number().when([], {
        is: () => !noCompany,
        then: (schema) => schema.min(1800, 'Year must be after 1800').max(new Date().getFullYear(), 'Year cannot be in the future').nullable(),
        otherwise: (schema) => schema.nullable()
      }),
      website: Yup.string().url('Invalid URL format').nullable(),
      entity_type: Yup.string().nullable(),
      // Personal address validation (when user doesn't own a company)
      personal_address_line1: Yup.string().when([], {
        is: () => noCompany,
        then: (schema) => schema.required("Address is required"),
        otherwise: (schema) => schema.nullable()
      }),
      personal_city: Yup.string().when([], {
        is: () => noCompany,
        then: (schema) => schema.required("City is required"),
        otherwise: (schema) => schema.nullable()
      }),
      personal_state: Yup.string().when([], {
        is: () => noCompany,
        then: (schema) => schema.required("State is required"),
        otherwise: (schema) => schema.nullable()
      }),
      personal_zipcode: Yup.string().when([], {
        is: () => noCompany,
        then: (schema) => schema.required("Zipcode is required").min(3, 'Zipcode must be at least 3 characters').max(10, 'Zipcode must be at most 10 characters'),
        otherwise: (schema) => schema.nullable()
      }),
      personal_country: Yup.string().when([], {
        is: () => noCompany,
        then: (schema) => schema.required("Country is required"),
        otherwise: (schema) => schema.nullable()
      }),
    }),

    
    // onSubmit: (values) => {
    //   console.log('check the values ----------',values)
    //   dispatch(registerUser(values,navigate));
    // }
    onSubmit: async (values) => {
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append("firstname", values.firstname);
      formData.append("lastname", values.lastname);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      selectedFiles.forEach((file) => {
        console.log(file ,'ka data ------------------')
        formData.append("filedata", file);
      });
      
      // Add company data if user owns a company
      if (!noCompany) {
        formData.append("has_company", "true");
        formData.append("company_name", values.company_name);
        formData.append("address_line1", values.address_line1);
        formData.append("address_line2", values.address_line2 || '');
        formData.append("city", values.city);
        formData.append("state", values.state);
        formData.append("zipcode", values.zipcode);
        formData.append("country", values.country);
        formData.append("company_phone", values.company_phone.replace(/\D/g, ''));
        formData.append("company_email", values.company_email);
        formData.append("website", values.website || '');
        formData.append("entity_type", values.entity_type || '');
        formData.append("year_of_formation", values.year_of_formation.toString());
      } else {
        // User doesn't own a company, send personal address
        formData.append("has_company", "false");
        formData.append("personal_address_line1", values.personal_address_line1);
        formData.append("personal_address_line2", values.personal_address_line2 || '');
        formData.append("personal_city", values.personal_city);
        formData.append("personal_state", values.personal_state);
        formData.append("personal_zipcode", values.personal_zipcode);
        formData.append("personal_country", values.personal_country);
      }
      try {
        const tt = await dispatch(registerUser(formData, navigate)); // ✅ only call once + await

        if (tt?.status === 'ERROR') {
          dispatch(registerUserFailed(tt.error || "Signup failed"));
          setTimeout(() => {
            dispatch(registerUserFailed(null)); 
            setIsSubmitting(false);
          }, 2000);
        }
      } catch (err:any) {
        console.error("Registration failed: ", err.message);
        setIsSubmitting(false);

        // optionally show toast or error UI
      } 
  }
});

const selectProperties = createSelector(
    (state: any) => state.Account,
    (account) => ({
      user: account.user,
      registrationError: account.registrationError,
      loading: account.loading,
    })
  );

  const { user, registrationError } = useSelector(selectProperties);



  useEffect(() => {
    dispatch(apiError());
  }, [dispatch]);

  return (
    <React.Fragment>
      <div className="home-btn d-none ">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages fullpagebg my-md-0 my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={10} lg={8} xl={7}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle bgImgGradient">
                  <Row>
                    <Col className="col-7">
                      <div className="text-dark p-4">
                        <h5 className="text-dark">Free Register</h5>
                        <p>Get your free BizServe account now.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logoImg}
                            alt=""
                            className=""
                            height="38"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {user && user ? (
                        <Alert color="success">
                          User registered successfully!
                        </Alert>
                      ) : null}

                      {registrationError && registrationError ? (
                        <Alert color="danger">{registrationError}</Alert>
                      ) : null}
                      <div className="mb-3">
                        <Label className="form-label">First Name<span className="text-danger px-1">*</span></Label>
                        <Input
                          name="firstname"
                          type="text"
                          placeholder="Enter First name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.firstname || ""}
                          invalid={
                            validation.touched.firstname && validation.errors.firstname ? true : false
                          }
                        />
                        {validation.touched.firstname && validation.errors.firstname ? (
                          <FormFeedback type="invalid">{validation.errors.firstname}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Last Name<span className="text-danger px-1">*</span></Label>
                        <Input
                          name="lastname"
                          type="text"
                          placeholder="Enter Last name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.lastname || ""}
                          invalid={
                            validation.touched.lastname && validation.errors.lastname ? true : false
                          }
                        />
                        {validation.touched.lastname && validation.errors.lastname ? (
                          <FormFeedback type="invalid">{validation.errors.lastname}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Email<span className="text-danger px-1">*</span></Label>
                        <Input
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      
                      <div className="mb-3">
                        <Label className="form-label">Phone<span className="text-danger px-1">*</span></Label>
                        <Input
                          name="phone"
                          type="text"
                          placeholder="Enter phone"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phone || ""}
                          invalid={
                            validation.touched.phone && validation.errors.phone ? true : false
                          }
                        />
                        {validation.touched.phone && validation.errors.phone ? (
                          <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>
                        ) : null}
                      </div>

                      {/* Company Ownership Toggle */}
                      <div className="mb-4 p-3 border rounded bg-light">
                        <div className="form-check form-switch">
                          <Input
                            type="checkbox"
                            className="form-check-input"
                            id="noCompanySwitch"
                            checked={noCompany}
                            onChange={(e) => setNoCompany(e.target.checked)}
                          />
                          <Label className="form-check-label" htmlFor="noCompanySwitch">
                            I do not own a company yet
                          </Label>
                        </div>
                      </div>

                      {/* Company Fields - Show only if user owns a company */}
                      {!noCompany && (
                        <div className="mb-4 p-3 border rounded">
                          <h6 className="mb-3 text-primary">
                            <i className="bx bx-buildings me-2"></i>
                            Company Information
                          </h6>

                          <div className="mb-3">
                            <Label className="form-label">Company Name<span className="text-danger px-1">*</span></Label>
                            <Input
                              name="company_name"
                              type="text"
                              placeholder="Enter company name"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.company_name || ""}
                              invalid={validation.touched.company_name && validation.errors.company_name ? true : false}
                            />
                            {validation.touched.company_name && validation.errors.company_name ? (
                              <FormFeedback type="invalid">{validation.errors.company_name}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">Company Email<span className="text-danger px-1">*</span></Label>
                            <Input
                              name="company_email"
                              type="email"
                              placeholder="Enter company email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.company_email || ""}
                              invalid={validation.touched.company_email && validation.errors.company_email ? true : false}
                            />
                            {validation.touched.company_email && validation.errors.company_email ? (
                              <FormFeedback type="invalid">{validation.errors.company_email}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">Company Phone<span className="text-danger px-1">*</span></Label>
                            <Input
                              name="company_phone"
                              type="text"
                              placeholder="(XXX) XXX-XXXX"
                              onChange={(e) => {
                                const formatted = formatPhoneForDisplay(e.target.value);
                                validation.setFieldValue('company_phone', formatted);
                              }}
                              onBlur={validation.handleBlur}
                              value={validation.values.company_phone || ""}
                              invalid={validation.touched.company_phone && validation.errors.company_phone ? true : false}
                              maxLength={14}
                            />
                            {validation.touched.company_phone && validation.errors.company_phone ? (
                              <FormFeedback type="invalid">{validation.errors.company_phone}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">Company Address Line 1<span className="text-danger px-1">*</span></Label>
                            <Input
                              name="address_line1"
                              type="text"
                              placeholder="Street address, P.O. box"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.address_line1 || ""}
                              invalid={validation.touched.address_line1 && validation.errors.address_line1 ? true : false}
                            />
                            {validation.touched.address_line1 && validation.errors.address_line1 ? (
                              <FormFeedback type="invalid">{validation.errors.address_line1}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">Company Address Line 2</Label>
                            <Input
                              name="address_line2"
                              type="text"
                              placeholder="Apartment, suite, unit, building, floor, etc."
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.address_line2 || ""}
                            />
                          </div>

                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label">City<span className="text-danger px-1">*</span></Label>
                                <Input
                                  name="city"
                                  type="text"
                                  placeholder="Enter city"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.city || ""}
                                  invalid={validation.touched.city && validation.errors.city ? true : false}
                                />
                                {validation.touched.city && validation.errors.city ? (
                                  <FormFeedback type="invalid">{validation.errors.city}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label">State/Province<span className="text-danger px-1">*</span></Label>
                                {getStatesForCountry(validation.values.country).length > 0 ? (
                                  <Input
                                    type="select"
                                    name="state"
                                    value={validation.values.state}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.state && validation.errors.state ? true : false}
                                  >
                                    <option value="">Select State</option>
                                    {getStatesForCountry(validation.values.country).map((state) => (
                                      <option key={state} value={state}>
                                        {state}
                                      </option>
                                    ))}
                                  </Input>
                                ) : (
                                  <Input
                                    type="text"
                                    name="state"
                                    placeholder="Enter state/province"
                                    value={validation.values.state}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.state && validation.errors.state ? true : false}
                                  />
                                )}
                                {validation.touched.state && validation.errors.state ? (
                                  <FormFeedback type="invalid">{validation.errors.state}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label">Country<span className="text-danger px-1">*</span></Label>
                                <Input
                                  type="select"
                                  name="country"
                                  value={validation.values.country}
                                  onChange={(e) => {
                                    validation.setFieldValue('country', e.target.value);
                                    validation.setFieldValue('state', '');
                                  }}
                                  onBlur={validation.handleBlur}
                                  invalid={validation.touched.country && validation.errors.country ? true : false}
                                >
                                  <option value="">Select Country</option>
                                  {COUNTRIES.map((country) => (
                                    <option key={country} value={country}>
                                      {country}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.country && validation.errors.country ? (
                                  <FormFeedback type="invalid">{validation.errors.country}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label">Zipcode<span className="text-danger px-1">*</span></Label>
                                <Input
                                  name="zipcode"
                                  type="text"
                                  placeholder="e.g., 12345 or 12345-6789"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.zipcode || ""}
                                  invalid={validation.touched.zipcode && validation.errors.zipcode ? true : false}
                                  maxLength={10}
                                />
                                {validation.touched.zipcode && validation.errors.zipcode ? (
                                  <FormFeedback type="invalid">{validation.errors.zipcode}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label">Company Type</Label>
                                <Input
                                  type="select"
                                  name="entity_type"
                                  value={validation.values.entity_type}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                >
                                  <option value="">Select Company Type</option>
                                  <option value="sole_proprietorship">Sole Proprietorship</option>
                                  <option value="partnership">Partnership</option>
                                  <option value="llc">LLC</option>
                                  <option value="corporation">Corporation</option>
                                  <option value="s_corp">S Corporation</option>
                                  <option value="non_profit">Non-Profit</option>
                                  <option value="other">Other</option>
                                </Input>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label">Year of Incorporation/Formation</Label>
                                <Input
                                  type="select"
                                  name="year_of_formation"
                                  value={validation.values.year_of_formation}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  invalid={validation.touched.year_of_formation && validation.errors.year_of_formation ? true : false}
                                >
                                  <option value="">Select Year</option>
                                  {Array.from({ length: 101 }, (_, i) => new Date().getFullYear() - i).map((year) => (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.year_of_formation && validation.errors.year_of_formation ? (
                                  <FormFeedback type="invalid">{validation.errors.year_of_formation}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>

                          <div className="mb-3">
                            <Label className="form-label">Website</Label>
                            <Input
                              name="website"
                              type="url"
                              placeholder="https://www.example.com"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.website || ""}
                              invalid={validation.touched.website && validation.errors.website ? true : false}
                            />
                            {validation.touched.website && validation.errors.website ? (
                              <FormFeedback type="invalid">{validation.errors.website}</FormFeedback>
                            ) : null}
                          </div>
                        </div>
                      )}

                      {/* Personal Address Fields - Show only if user doesn't own a company */}
                      {noCompany && (
                        <div className="mb-4 p-3 border rounded">
                          <h6 className="mb-3 text-primary">
                            <i className="bx bx-home me-2"></i>
                            Personal Address
                          </h6>

                          <div className="mb-3">
                            <Label className="form-label">Address Line 1<span className="text-danger px-1">*</span></Label>
                            <Input
                              name="personal_address_line1"
                              type="text"
                              placeholder="Street address, P.O. box"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.personal_address_line1 || ""}
                              invalid={validation.touched.personal_address_line1 && validation.errors.personal_address_line1 ? true : false}
                            />
                            {validation.touched.personal_address_line1 && validation.errors.personal_address_line1 ? (
                              <FormFeedback type="invalid">{validation.errors.personal_address_line1}</FormFeedback>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label className="form-label">Address Line 2</Label>
                            <Input
                              name="personal_address_line2"
                              type="text"
                              placeholder="Apartment, suite, unit, building, floor, etc."
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.personal_address_line2 || ""}
                            />
                          </div>

                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label">City<span className="text-danger px-1">*</span></Label>
                                <Input
                                  name="personal_city"
                                  type="text"
                                  placeholder="Enter city"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.personal_city || ""}
                                  invalid={validation.touched.personal_city && validation.errors.personal_city ? true : false}
                                />
                                {validation.touched.personal_city && validation.errors.personal_city ? (
                                  <FormFeedback type="invalid">{validation.errors.personal_city}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label">State/Province<span className="text-danger px-1">*</span></Label>
                                {getStatesForCountry(validation.values.personal_country).length > 0 ? (
                                  <Input
                                    type="select"
                                    name="personal_state"
                                    value={validation.values.personal_state}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.personal_state && validation.errors.personal_state ? true : false}
                                  >
                                    <option value="">Select State</option>
                                    {getStatesForCountry(validation.values.personal_country).map((state) => (
                                      <option key={state} value={state}>
                                        {state}
                                      </option>
                                    ))}
                                  </Input>
                                ) : (
                                  <Input
                                    type="text"
                                    name="personal_state"
                                    placeholder="Enter state/province"
                                    value={validation.values.personal_state}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={validation.touched.personal_state && validation.errors.personal_state ? true : false}
                                  />
                                )}
                                {validation.touched.personal_state && validation.errors.personal_state ? (
                                  <FormFeedback type="invalid">{validation.errors.personal_state}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label">Country<span className="text-danger px-1">*</span></Label>
                                <Input
                                  type="select"
                                  name="personal_country"
                                  value={validation.values.personal_country}
                                  onChange={(e) => {
                                    validation.setFieldValue('personal_country', e.target.value);
                                    validation.setFieldValue('personal_state', '');
                                  }}
                                  onBlur={validation.handleBlur}
                                  invalid={validation.touched.personal_country && validation.errors.personal_country ? true : false}
                                >
                                  <option value="">Select Country</option>
                                  {COUNTRIES.map((country) => (
                                    <option key={country} value={country}>
                                      {country}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.personal_country && validation.errors.personal_country ? (
                                  <FormFeedback type="invalid">{validation.errors.personal_country}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label">Zipcode<span className="text-danger px-1">*</span></Label>
                                <Input
                                  name="personal_zipcode"
                                  type="text"
                                  placeholder="e.g., 12345 or 12345-6789"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.personal_zipcode || ""}
                                  invalid={validation.touched.personal_zipcode && validation.errors.personal_zipcode ? true : false}
                                  maxLength={10}
                                />
                                {validation.touched.personal_zipcode && validation.errors.personal_zipcode ? (
                                  <FormFeedback type="invalid">{validation.errors.personal_zipcode}</FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}

                      <div className="mb-3">
                        <Label className="form-label">Profile Picture</Label>
                        <Form>
                            <Dropzone
                              onDrop={(acceptedFiles:any) => {
                                handleAcceptedFiles(acceptedFiles)
                              }}
                            >
                              {({ getRootProps, getInputProps }:any) => (
                                <div className="dropzone dropZoneSize">
                                  <div
                                    className="dz-message needsclick mt-2 p-0"
                                    {...getRootProps()}
                                  >
                                    <input {...getInputProps()} />
                                    <div className="mb-2">
                                      <i className="display-5 text-muted bx bxs-cloud-upload" />
                                    </div>
                                    <h4 className="font-size-14">Upload a file.</h4>
                                  </div>
                                </div>
                              )}
                            </Dropzone>
                            {/* {validation.errors.filedata && validation.touched.filedata && (
                              <div className="text-danger mt-1">{validation.errors.filedata}</div>
                            )} */}
                            <div className="dropzone-previews mt-3" id="file-previews">
                              {selectedFiles.map((f:any, i:any) => {
                                return (
                                  <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                  >
                                    <div className="p-2">
                                      <Row className="align-items-center">
                                        <Col className="col-auto">
                                          <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                          />
                                        </Col>
                                        <Col>
                                          <Link
                                            to="#"
                                            className="text-muted font-weight-bold"
                                          >
                                            {f.name}
                                          </Link>
                                          <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                          </p>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Card>
                                )
                              })}
                            </div>
                          </Form>
                      </div>

                      <div className="mt-4">
                      <button
                        className="btn btn-primary btn-block"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? 'Registering...' : 'Register'}
                      </button>
                      </div>

                      <div className="mt-4 text-center">
                        <p className="mb-0">
                          By registering you agree to the BizServe{" "}
                          <Link to="/terms-and-conditions" className="text-primary" target="_blank" rel="noopener noreferrer">
                            Terms and Conditions
                          </Link>
                          {" "}and{" "}
                          <Link to="/privacy-policy" className="text-primary" target="_blank" rel="noopener noreferrer">
                            Privacy Policy
                          </Link>
                        </p>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Already have an account ?{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {" "}
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} BizServe. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by BizServe LLC
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Register;
